import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { AppDialogRef } from '../../components/dialog/dialog-ref';
import { DIALOG_IMPORTS } from '../../components/dialog/dialog.imports';

export type RegenerateAfterEditResult = 'close' | 'skip' | 'regenerate';

@Component({
  selector: 'app-regenerate-after-edit',
  standalone: true,
  imports: [...DIALOG_IMPORTS, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: './regenerate-after-edit.component.html',
})
export class RegenerateAfterEditComponent {
  constructor(
    private dialogRef: AppDialogRef<RegenerateAfterEditComponent, RegenerateAfterEditResult>
  ) {}

  onClose(): void {
    this.dialogRef.close('close');
  }

  onSkip(): void {
    this.dialogRef.close('skip');
  }

  onRegenerate(): void {
    this.dialogRef.close('regenerate');
  }
}
